module.exports = "<router-outlet></router-outlet>\n<ngx-spinner type = \"ball-scale-ripple-multiple\"></ngx-spinner>\n"